export default function formatDateString(
  dateString: string,
  locale: string = 'en-US'
) {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  return date.toLocaleDateString(locale, options);
}

export const MINUTE_IN_MS = 60 * 1000;
